import { isArray, isObject } from 'lodash-es'

export const toType = (obj: any): string => {
  if (isArray(obj)) return 'array'
  if (isObject(obj)) return 'object'
  return typeof obj
}

export const normalizeToInterval = (v: number, min: number, max: number): number => {
  if (max <= min) {
    return min
  }

  const size = max - min + 1

  let index = min + ((v - min) % size)
  if (index < min) {
    index = size + index
  }

  return index === 0 ? 0 : index // fix negative zero (-0) after remainder (%) example (-10 % 10) => -0
}

export const stopAndPrevent = (e: Event): void => {
  if (e.cancelable) {
    e.preventDefault()
  }
  e.stopPropagation()
}
